import { render, staticRenderFns } from "./FriendApply.vue?vue&type=template&id=083819eb&scoped=true"
import script from "./FriendApply.vue?vue&type=script&lang=js"
export * from "./FriendApply.vue?vue&type=script&lang=js"
import style0 from "./FriendApply.vue?vue&type=style&index=0&id=083819eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083819eb",
  null
  
)

export default component.exports